export function padTimeSeriesData(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dbData: any[],
    dateField: string,
    valueField: string,
    startDate: Date,
    endDate: Date,
    unit: "day" | "week" | "month"
) {
    // 1. Map DB results to a fast dictionary using YYYY-MM-DD as the safe key
    const dataMap = new Map<string, number>()

    dbData?.forEach((row) => {
        // Safely parse the DB date and extract the YYYY-MM-DD string
        const dateObj = new Date(row[dateField])
        const dateKey = dateObj.toISOString().split("T")[0]
        dataMap.set(dateKey, Number(row[valueField]))
    })

    // 2. Generate the timeline
    const paddedArray = []

    // Clone startDate so we don't mutate the original object passed in
    const current = new Date(startDate)

    // Align 'current' to match Postgres DATE_TRUNC boundaries
    if (unit === "month") {
        current.setDate(1) // Force to 1st of the month
    } else if (unit === "week") {
        // Force to the closest Monday (Postgres week start)
        const day = current.getDay()
        const diff = current.getDate() - day + (day === 0 ? -6 : 1)
        current.setDate(diff)
    }

    // 3. Step forward and pad
    while (current <= endDate) {
        // Use the ISO string to check our dictionary safely
        const dateKey = current.toISOString().split("T")[0]

        paddedArray.push({
            x: current.getTime(), // <--- Changed for visx: Returns numeric timestamp (ms)
            y: dataMap.get(dateKey) || 0,
        })

        // Step the calendar forward safely
        if (unit === "day") {
            current.setDate(current.getDate() + 1)
        } else if (unit === "week") {
            current.setDate(current.getDate() + 7)
        } else if (unit === "month") {
            current.setMonth(current.getMonth() + 1)
        }
    }

    return paddedArray
}
